// extracted by mini-css-extract-plugin
export default {"colorBlueRibbon":"#2B5FF5","dropdown":"vWPtA9E3guSbYl0IlDbA","dropdownWrapper":"lmVItDueqaqD9zZLOIAo"};